import React, { useEffect, useMemo, useState } from 'react'
import Main from '../Components/Main';
import PageContainer from '../Components/PageContainer';
import Modal from '../Components/Modal';
import VehicleForm from '../Components/VehicleForm';
import CollapseCard from '../Components/CollapseCard';
import VehicleList from '../Components/VehicleList';
import { getAllVehicles, saveVehicle } from '../Service/VehicleService';
import { useToast } from '../Components/toast/ToastProvider';
import { getAllVendors } from '../Service/VendorService';

const VehiclePage = () => {
    const [vehicleForm, setVehicleForm] = useState({
        vendor_id: '',
        vehicle_number: ''
    });

    const [vehicleData, setVehicleData] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);

    // Vendor filter
    const [vendorFilter, setVendorFilter] = useState('');

    const toast = useToast();

    useEffect(() => {
        fetchVehicle();
        fetchVendor();
    }, []);

    const fetchVendor = async () => {
        try {
            const res = await getAllVendors();
            setVendors(res.data);
        } catch (err) {
            toast(err.message || 'Failed to fetch vendors', "ERROR");
        }
    };

    const fetchVehicle = async () => {
        try {
            const res = await getAllVehicles();
            setVehicleData(res.data);
        } catch (err) {
            toast(err.message || 'Failed to fetch vehicle', "ERROR");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!vehicleForm.vendor_id || !vehicleForm.vehicle_number) {
            toast('Please fill all fields', "ERROR");
            return;
        }

        const exist = vehicleData.find(
            v =>
                v.vehicle_number.toLowerCase() ===
                    vehicleForm.vehicle_number.toLowerCase() &&
                v.id !== vehicleForm.id
        );

        if (exist) {
            toast('Vehicle number already exists', "ERROR");
            return;
        }

        try {
            await saveVehicle(vehicleForm);

            toast(
                vehicleForm.id
                    ? 'Vehicle updated successfully'
                    : 'Vehicle added successfully',
                'SUCCESS'
            );

            fetchVehicle();
            handleCancel();
        } catch (err) {
            toast(err.message || 'Failed to save vehicle', 'ERROR');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setVehicleForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEdit = (item) => {
        setVehicleForm({
            id: item.id,
            vendor_id: item.vendor_id,
            vehicle_number: item.vehicle_number
        });

        setShowModal(true);
    };

    const handleCancel = () => {
        setVehicleForm({
            vendor_id: '',
            vehicle_number: ''
        });

        setShowModal(false);
    };

    // Filter vehicles by vendor
    const filteredVehicleData = useMemo(() => {
        if (!vendorFilter) {
            return vehicleData;
        }

        return vehicleData.filter(
            vehicle => String(vehicle.vendor_id) === String(vendorFilter)
        );
    }, [vehicleData, vendorFilter]);

    return (
        <Main>
            <PageContainer
                titlePage="Vehicle"
                buttonText="ADD"
                onButtonClick={() => {
                    setVehicleForm({
                        vendor_id: '',
                        vehicle_number: ''
                    });
                    setShowModal(true);
                }}
            >
                <Modal
                    visible={showModal}
                    size="lg"
                    onClose={handleCancel}
                    headerText={
                        vehicleForm.id ? 'Edit Vehicle' : 'Add Vehicle'
                    }
                >
                    <VehicleForm
                        handleChange={handleChange}
                        vehicleForm={vehicleForm}
                        handleSubmit={handleSubmit}
                        handleCancel={handleCancel}
                        vendors={vendors}
                        setVendors={setVendors}
                        setVehicleForm={setVehicleForm}
                    />
                </Modal>

                <CollapseCard title="Vehicle">

                    {/* Vendor Filter */}
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">
                                Vendor
                            </label>

                            <select
                                className="form-select"
                                value={vendorFilter}
                                onChange={(e) =>
                                    setVendorFilter(e.target.value)
                                }
                            >
                                <option value="">
                                    All Vendors
                                </option>

                                {vendors.sort((a, b) => a.name.localeCompare(b.name)).map(vendor => (
                                    <option
                                        key={vendor.id}
                                        value={vendor.id}
                                    >
                                        {vendor.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <VehicleList
                        vehicleData={filteredVehicleData}
                        handleEdit={handleEdit}
                        vendors={vendors}
                    />

                </CollapseCard>
            </PageContainer>
        </Main>
    );
};

export default VehiclePage;